import { LogOut } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

import { Button } from '@/components/ui/button'
import { APP_ROUTES } from '@/libs/constants'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { setImpersonatedOrg } from '@/store/slices/authSlice'

export function ImpersonationBanner() {
  const impersonated = useAppSelector((s) => s.auth.impersonatedOrg)
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  if (!impersonated) return null

  const exit = () => {
    dispatch(setImpersonatedOrg(null))
    navigate(APP_ROUTES.admin.organizations)
  }

  return (
    <div className="sticky top-0 z-40 flex items-center justify-between gap-3 bg-amber-500 text-amber-950 px-4 py-2 text-sm shadow">
      <span>
        <strong>Acting as</strong> {impersonated.orgName} — all actions affect this organization.
      </span>
      <Button size="sm" variant="secondary" onClick={exit} className="h-7">
        <LogOut className="h-3.5 w-3.5 mr-1.5" /> Exit
      </Button>
    </div>
  )
}
